/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Color(props) {
    return (
        <SvgIcon {...props}>
            <path d="M8.998,8.12c0.005-0.23-0.02-0.47-0.066-0.716c-0.077-0.44-0.211-0.854-0.403-1.239 C7.101,3.264,4.54,0.735,4.503,0.699V0.697H4.499v0.002c-0.037,0.036-2.7,2.521-4.043,5.506C0.288,6.555,0.158,6.93,0.084,7.323 C0.021,7.617-0.009,7.901,0.002,8.172c0,2.499,2.014,4.525,4.5,4.525C6.985,12.697,9,10.671,9,8.172 C9,8.154,8.998,8.136,8.998,8.12z M4.501,11.174V9.9c0.969,0,1.757-0.793,1.757-1.768h1.267 C7.525,9.809,6.168,11.174,4.501,11.174z" />
        </SvgIcon>
    );
}

Color.defaultProps = {
    viewBox: '0 0 9 16'
};

export default Color;
